// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadOrders from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import CardList, { CardListStyles } from "@insite/content-library/Components/CardList";
// import CardListHeading from "@insite/content-library/Components/CardListHeading"; // Starter Custom Code
// import OrderSummaryCard, { OrderSummaryCardStyles } from "@insite/content-library/Components/OrderSummaryCard"; // Store Custom Code
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as cssLinter from "css";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import loadOrderStatusMappings from "@insite/client-framework/Store/Data/OrderStatusMappings/Handlers/LoadOrderStatusMappings";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
// import CardListHeading from "@store/Overrides/Components/CardListHeading"; // Store Custom Code
import { tableProps } from "@store/Themes/common/props/table";
import { typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import withHookProps, { HookPropsInjector } from "@toolkit/Framework/Common/Utilities/withHookProps";

interface HookProps {
    persistentDataView: ReturnType<typeof getOrdersDataView>;
}

const hookPropsInjector: HookPropsInjector<Props, HookProps> = ({ ordersDataView }) => ({
    persistentDataView: usePersistentDataView(ordersDataView),
});
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import Img, { ImgProps } from "@store/MobiusOverrides/Img/Img";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import OrderSummaryCard, { OrderSummaryCardStyles } from "@store/Overrides/Components/OrderSummaryCard";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const enum fields {
    numberOfRecords = "numberOfRecords",
    customCSS = "customCSS",
    // Store Custom Code
    showOrderNumber = "showOrderNumber",
    showDate = "showDate",
    showOrderTotal = "showOrderTotal",
    showStatus = "showStatus",
    showShipTo = "showShipTo",
    showPONumber = "showPONumber",
    showReorderProducts = "showReorderProducts",
    showRequestedDeliveryDate = "showRequestedDeliveryDate",
    imageUrl = "imageUrl",
    showWarehouse = "showWarehouse",
    showHeader = "showHeader",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfRecords]: number;
        [fields.customCSS]: string;
        // Store Custom Code
        [fields.showOrderNumber]: boolean;
        [fields.showDate]: boolean;
        [fields.showOrderTotal]: boolean;
        [fields.showStatus]: boolean;
        [fields.showShipTo]: boolean;
        [fields.showPONumber]: boolean;
        [fields.showReorderProducts]: boolean;
        [fields.showRequestedDeliveryDate]: boolean;
        [fields.imageUrl]: string;
        [fields.showWarehouse]: boolean;
        [fields.showHeader]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = session.isAuthenticated && !session.isGuest;
    const orderStatusMappingDataView = getOrderStatusMappingDataView(state); // Starter Custom Code
    return {
        ordersDataView: getOrdersDataView(state, recentOrdersParameter),
        orderHistoryPageLink: getPageLinkByPageType(state, "OrderHistoryPage"),
        settingsCollection: getSettingsCollection(state),
        canViewOrders: isAuthenticated && (session.userRoles || "").indexOf("Requisitioner") === -1,
        // Store Custom Code
        showPoNumber: getSettingsCollection(state).orderSettings.showPoNumber,
        isVmiOrderHistoryPage: state.pages.orderHistory.isVmiOrderHistoryPage,
        currentShipTo: getCurrentShipToState(state).value,
        // Starter Custom Code
        shouldLoadOrderStatusMappings: !orderStatusMappingDataView.value && !orderStatusMappingDataView.isLoading,
    };
};

const mapDispatchToProps = {
    loadOrders,
    // Starter Custom Code
    loadOrderStatusMappings,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HookProps; // Starter Custom Code

export interface RecentOrdersStyles {
    cardList?: CardListStyles;
    errorGridItem?: GridItemProps;
    errorText?: TypographyPresentationProps;
    noOrdersFoundGridItem?: GridItemProps;
    noOrdersFoundText?: TypographyPresentationProps;
    cardContainer?: CardContainerStyles;
    orderSummaryCard?: OrderSummaryCardStyles;
    // Starter Custom Code
    wrapper?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    orderNumberHeader?: DataTableHeaderProps;
    dateHeader?: DataTableHeaderProps;
    shipToHeader?: DataTableHeaderProps;
    customerPOHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    orderTotalHeader?: DataTableHeaderProps;
    // Store Custom Code
    reorderHeader?: DataTableHeaderProps;
    warehouseHeader?: DataTableHeaderProps;
    headingActionWrap?: InjectableCss;
    linkImg?: ImgProps;
}

export const recentOrdersStyles: RecentOrdersStyles = {
    loadingOverlay: { minHeight: 80 },
    tableWrapper: tableProps.wrapper,
    noOrdersFoundText: typographyGetNoResultsProps(),
    dataTable: tableProps.dataTable,
    shipToHeader: tableProps.tightHeader,
    orderTotalHeader: tableProps.amountHeader,
    /* Store Custom Code - Start */
    reorderHeader: tableProps.tightHeader,
    headingActionWrap: {
        css: css`
            display: flex;
            gap: ${pxToRem(10)};
            align-items: center;
        `,
    },
    linkImg: {
        css: css`
            width: 100%;
            max-width: ${pxToRem(50)};
            height: auto;
        `,
    },
    /* Store Custom Code - End */
};

/* Starter Custom Code - Start */
const defaultCustomCss = `.card-list-heading{
}

.view-all-link{
}

.no-orders-found-text{
}`;
/* Starter Custom Code - End */

let recentOrdersParameter: GetOrdersApiParameter = {
    customerSequence: "-1",
    page: 1,
    sort: "OrderDate DESC, WebOrderNumber DESC", // Store Custom Code
    additionalExpands: ["getLocations"], // Store Custom Code
};

const styles = recentOrdersStyles;

class RecentOrders extends React.Component<Props> {
    /* Starter Custom Code - Start */
    UNSAFE_componentWillMount() {
        if (this.props.shouldLoadOrderStatusMappings) {
            this.props.loadOrderStatusMappings();
        }
    }
    /* Starter Custom Code - End */
    componentDidMount() {
        recentOrdersParameter.customerSequence = this.props.currentShipTo?.customerSequence || "-1"; // Store Custom Code
        recentOrdersParameter.pageSize = this.props.fields.numberOfRecords;
        if (
            this.props.canViewOrders &&
            !this.props.ordersDataView.value &&
            this.props.currentShipTo?.customerSequence // Store Custom Code
        ) {
            this.props.loadOrders(recentOrdersParameter);
        }
    }

    /* Store Custom Code - Start */
    componentDidUpdate(prevProps: Props) {
        if (prevProps.currentShipTo !== this.props.currentShipTo) {
            this.componentDidMount();
        }
    }
    /* Store Custom Code - End */

    render() {
        const { ordersDataView, orderHistoryPageLink, settingsCollection, canViewOrders } = this.props;
        if (!canViewOrders /* Starter Removed - !ordersDataView.value */) {
            return null;
        }

        const orderHistoryUrl = orderHistoryPageLink ? orderHistoryPageLink.url : undefined;

        /* Starter Custom Code - Start */
        const customCssWrapper = css`
            ${styles.wrapper?.css}
            ${this.props.fields.customCSS}
        `;

        const hasNoResults = !ordersDataView.value || ordersDataView.value.length === 0;

        /* Store Custom Code - Start */
        const {
            showOrderNumber = true,
            showDate = true,
            showOrderTotal = true,
            showStatus = true,
            showShipTo = true,
            showPONumber = true,
            showReorderProducts = true,
            imageUrl,
            showWarehouse = true,
            showRequestedDeliveryDate = true,
            showHeader = false,
        } = this.props.fields;

        const showRequestedDeliveryDateDisplay =
            showRequestedDeliveryDate &&
            (ordersDataView.value ? ordersDataView.value.some(x => x.requestedDeliveryDateDisplay) : true);

        const titleComponent = (
            <StyledWrapper {...styles.headingActionWrap}>
                {imageUrl && (
                    <Img src={imageUrl} altText={translate("Recent orders icon")} loading="lazy" {...styles.linkImg} />
                )}
                <Typography>{translate("Recent Orders")}</Typography>
            </StyledWrapper>
        );
        /* Store Custom Code - End */

        return (
            <StyledWrapper
                {...styles.wrapper}
                css={customCssWrapper}
                data-test-selector="widget_RecentOrders"
                // Store Custom Code
                as="nav"
            >
                {showHeader && (
                    <CardListHeading
                        heading={titleComponent} // Store Custom Code
                        viewAllUrl={orderHistoryUrl}
                        hasNoResults={hasNoResults}
                        // Store Custom Code
                        viewAllText={translate("View All Orders")}
                    />
                )}
                <DataViewLoadingOverlay {...styles.loadingOverlay} dataView={this.props.persistentDataView}>
                    {hasNoResults ? (
                        <Typography
                            className="no-orders-found-text"
                            {...styles.noOrdersFoundText}
                            data-test-selector="recentOrders_NoOrdersFound"
                        >
                            {translate("No orders found")}
                        </Typography>
                    ) : (
                        <StyledWrapper {...styles.tableWrapper}>
                            <DataTable {...styles.dataTable}>
                                <DataTableHead>
                                    {/* Store Custom Code - Start */}
                                    {showOrderNumber && (
                                        <DataTableHeader
                                            {...styles.orderNumberHeader}
                                            title={translate("Order Number")}
                                        >
                                            {translate("Greif Order #")}
                                        </DataTableHeader>
                                    )}
                                    {showPONumber && this.props.showPoNumber && (
                                        <DataTableHeader
                                            {...styles.customerPOHeader}
                                            title={translate("Purchase Order Number")}
                                        >
                                            {translate("PO #")}
                                        </DataTableHeader>
                                    )}
                                    {showDate && (
                                        <DataTableHeader {...styles.dateHeader}>
                                            {translate("Order Date")}
                                        </DataTableHeader>
                                    )}
                                    {showRequestedDeliveryDateDisplay && (
                                        <DataTableHeader {...styles.dateHeader}>
                                            {translate("Requested Date")}
                                        </DataTableHeader>
                                    )}
                                    {showShipTo && (
                                        <DataTableHeader {...styles.shipToHeader}>
                                            {translate("Ship To / Pick Up")}
                                        </DataTableHeader>
                                    )}
                                    {showOrderTotal && (
                                        <DataTableHeader {...styles.orderTotalHeader}>
                                            {translate("Amount")}
                                        </DataTableHeader>
                                    )}
                                    {showStatus && (
                                        <DataTableHeader {...styles.statusHeader}>
                                            {translate("Order Status")}
                                        </DataTableHeader>
                                    )}
                                    {showWarehouse && (
                                        <DataTableHeader {...styles.warehouseHeader}>
                                            {translate("Greif Location - Recent Orders")}
                                        </DataTableHeader>
                                    )}
                                    {showReorderProducts && !this.props.isVmiOrderHistoryPage && (
                                        <DataTableHeader {...styles.reorderHeader} title={translate("Reorder")} />
                                    )}
                                    {/* Store Custom Code - End */}
                                </DataTableHead>
                                <DataTableBody>
                                    {ordersDataView.value?.map(
                                        order =>
                                            order !== null && (
                                                <OrderSummaryCard
                                                    key={order.id}
                                                    order={order}
                                                    orderSettings={settingsCollection.orderSettings}
                                                    extendedStyles={styles.orderSummaryCard}
                                                    // Store Custom Code
                                                    showOrderNumber={showOrderNumber}
                                                    showDate={showDate}
                                                    showOrderTotal={showOrderTotal}
                                                    showStatus={showStatus}
                                                    showShipTo={showShipTo}
                                                    showPONumber={showPONumber}
                                                    showRequestedDeliveryDate={showRequestedDeliveryDateDisplay}
                                                    showReorderProducts={showReorderProducts}
                                                    showWarehouse={showWarehouse}
                                                />
                                            ),
                                    )}
                                </DataTableBody>
                            </DataTable>
                        </StyledWrapper>
                    )}
                </DataViewLoadingOverlay>
            </StyledWrapper>
        );
        /* Starter Custom Code - End */
    }
}

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHookProps(RecentOrders, hookPropsInjector)), // Starter Custom Code
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.numberOfRecords,
                displayName: "Number of Recent Orders Displayed",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 5,
                fieldType: "General",
                sortOrder: 1,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            /* Store Custom Code - Start */
            {
                name: fields.showOrderNumber,
                displayName: "Order #",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => false,
                fieldType: "General",
                sortOrder: 0,
            },
            {
                name: fields.showDate,
                displayName: "Date",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.showOrderTotal,
                displayName: "Order Total",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.showStatus,
                displayName: "Status",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.showShipTo,
                displayName: "Ship To/Pick Up",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 4,
            },
            {
                name: fields.showPONumber,
                displayName: "PO #",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 5,
            },
            {
                name: fields.showReorderProducts,
                displayName: "Reorder",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 6,
            },
            {
                name: fields.showRequestedDeliveryDate,
                displayName: "Requested Delivery Date",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 7,
            },
            {
                name: fields.showWarehouse,
                displayName: "Greif Location",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 8,
            },
            {
                name: fields.imageUrl,
                displayName: "Product Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 9,
            },
            {
                name: fields.showHeader,
                displayName: "Show Header and View All Link",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 10,
            },
            /* Store Custom Code - End */
        ],
    },
};

export default widgetModule;
